import { render, staticRenderFns } from "./SampleInfoSection.vue?vue&type=template&id=54e592ba&"
import script from "./SampleInfoSection.vue?vue&type=script&lang=js&"
export * from "./SampleInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports